import { render, staticRenderFns } from "./inn-selector.vue?vue&type=template&id=0c2da28f&"
import script from "./inn-selector.vue?vue&type=script&lang=ts&"
export * from "./inn-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports